import request from '@/utils/request'
import { addUrlPerFix } from '@/utils'

export function loginByUsername (username, password) {
  const data = {
    username,
    password
  }
  return request({
    url: '/login/login',
    method: 'post',
    data
  })
}

export function logout () {
  return request({
    url: '/login/logout',
    method: 'post'
  })
}

export function getUserInfo (token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token }
  })
}

export function getDetail (data) {
  return request({
    url: addUrlPerFix(process.env.VUE_APP_BASEP_URL) + '/apis/basap/getDetail',
    method: 'post',
    data
  })
}
